'use strict'

const isNode = require('detect-node')

if (isNode) {
  module.exports = require('crypto')
} else {
  module.exports = require('crypto-browserify')
}



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 72
// module chunks = 0